import { PlatinumSettingsPage } from "./PlatinumSettingsPage";

export default PlatinumSettingsPage;